import { dew as _configurationsDew } from "../../configurations";
import { dew as _chronoDew } from "../../chrono";
import { dew as _FRCasualDateParserDew } from "./parsers/FRCasualDateParser";
import { dew as _FRCasualTimeParserDew } from "./parsers/FRCasualTimeParser";
import { dew as _SlashDateFormatParserDew } from "../../common/parsers/SlashDateFormatParser";
import { dew as _FRTimeExpressionParserDew } from "./parsers/FRTimeExpressionParser";
import { dew as _FRMergeDateTimeRefinerDew } from "./refiners/FRMergeDateTimeRefiner";
import { dew as _FRMergeDateRangeRefinerDew } from "./refiners/FRMergeDateRangeRefiner";
import { dew as _FRWeekdayParserDew } from "./parsers/FRWeekdayParser";
import { dew as _FRSpecificTimeExpressionParserDew } from "./parsers/FRSpecificTimeExpressionParser";
import { dew as _FRMonthNameLittleEndianParserDew } from "./parsers/FRMonthNameLittleEndianParser";
import { dew as _FRTimeUnitAgoFormatParserDew } from "./parsers/FRTimeUnitAgoFormatParser";
import { dew as _FRTimeUnitWithinFormatParserDew } from "./parsers/FRTimeUnitWithinFormatParser";
import { dew as _FRTimeUnitRelativeFormatParserDew } from "./parsers/FRTimeUnitRelativeFormatParser";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createConfiguration = exports.createCasualConfiguration = exports.parseDate = exports.parse = exports.strict = exports.casual = void 0;
  const configurations_1 = _configurationsDew();
  const chrono_1 = _chronoDew();
  const FRCasualDateParser_1 = __importDefault(_FRCasualDateParserDew());
  const FRCasualTimeParser_1 = __importDefault(_FRCasualTimeParserDew());
  const SlashDateFormatParser_1 = __importDefault(_SlashDateFormatParserDew());
  const FRTimeExpressionParser_1 = __importDefault(_FRTimeExpressionParserDew());
  const FRMergeDateTimeRefiner_1 = __importDefault(_FRMergeDateTimeRefinerDew());
  const FRMergeDateRangeRefiner_1 = __importDefault(_FRMergeDateRangeRefinerDew());
  const FRWeekdayParser_1 = __importDefault(_FRWeekdayParserDew());
  const FRSpecificTimeExpressionParser_1 = __importDefault(_FRSpecificTimeExpressionParserDew());
  const FRMonthNameLittleEndianParser_1 = __importDefault(_FRMonthNameLittleEndianParserDew());
  const FRTimeUnitAgoFormatParser_1 = __importDefault(_FRTimeUnitAgoFormatParserDew());
  const FRTimeUnitWithinFormatParser_1 = __importDefault(_FRTimeUnitWithinFormatParserDew());
  const FRTimeUnitRelativeFormatParser_1 = __importDefault(_FRTimeUnitRelativeFormatParserDew());
  exports.casual = new chrono_1.Chrono(createCasualConfiguration());
  exports.strict = new chrono_1.Chrono(createConfiguration(true));
  function parse(text, ref, option) {
    return exports.casual.parse(text, ref, option);
  }
  exports.parse = parse;
  function parseDate(text, ref, option) {
    return exports.casual.parseDate(text, ref, option);
  }
  exports.parseDate = parseDate;
  function createCasualConfiguration(littleEndian = true) {
    const option = createConfiguration(false, littleEndian);
    option.parsers.unshift(new FRCasualDateParser_1.default());
    option.parsers.unshift(new FRCasualTimeParser_1.default());
    option.parsers.unshift(new FRTimeUnitRelativeFormatParser_1.default());
    return option;
  }
  exports.createCasualConfiguration = createCasualConfiguration;
  function createConfiguration(strictMode = true, littleEndian = true) {
    return configurations_1.includeCommonConfiguration({
      parsers: [new SlashDateFormatParser_1.default(littleEndian), new FRMonthNameLittleEndianParser_1.default(), new FRTimeExpressionParser_1.default(), new FRSpecificTimeExpressionParser_1.default(), new FRTimeUnitAgoFormatParser_1.default(), new FRTimeUnitWithinFormatParser_1.default(), new FRWeekdayParser_1.default()],
      refiners: [new FRMergeDateTimeRefiner_1.default(), new FRMergeDateRangeRefiner_1.default()]
    }, strictMode);
  }
  exports.createConfiguration = createConfiguration;
  //# sourceMappingURL=index.js.map
  return exports;
}